export const bankPaymentFilterCheckResolvedOptions = [
    {value: true, label: "admin.common.payments.datatable.navigation.filter.select:checked"},
    {value: false, label: "admin.common.payments.datatable.navigation.filter.select:unchecked"}
]